import {
  Box,
  Card,
  Flex,
  Button,
  useDisclosure,
  Modal,
  ModalContent,
  ModalBody,
  Skeleton,
  ModalCloseButton,
  ModalHeader,
  ModalOverlay,
  CardBody,
} from "@chakra-ui/react";
import { AdminCompany } from "models/company";
import { InfoDisplayValue } from "components/DataDisplay/InfoDisplayValue";
import { useCurrentCompanyAdminQuery } from "features/Company/hooks";
import { COMPANY_EMAIL_DEFAULT_FROM, COMPANY_EMAIL_DEFAULT_REPLY_TO, EmailSettingsForm } from "./EmailSettingsForm";

interface EmailSettingsCardProps {
  company?: AdminCompany;
  editClickedHandler?: () => void;
}

function EmailSettingsCard({ company = undefined, editClickedHandler = () => null }: EmailSettingsCardProps) {
  return (
    <Skeleton isLoaded={!!company}>
      <Card minWidth="900px" width="calc(100% - 200px)" mt="4">
        <CardBody>
          <Flex justifyContent="space-between" w="100%" alignItems="center" p={5}>
            <Box opacity="70%" fontSize="2xl">
              Default Email Settings
            </Box>
            <Button onClick={editClickedHandler} px="20px">
              Edit
            </Button>
          </Flex>
          <Flex direction="column" px={10}>
            <InfoDisplayValue value={company?.customEmailDefaultFrom} label={COMPANY_EMAIL_DEFAULT_FROM.label} />
            <InfoDisplayValue value={company?.customEmailDefaultReplyTo} label={COMPANY_EMAIL_DEFAULT_REPLY_TO.label} />
          </Flex>
        </CardBody>
      </Card>
    </Skeleton>
  );
}

export default function EmailSettings() {
  const { onOpen, onClose, isOpen } = useDisclosure();
  const { data, isLoading } = useCurrentCompanyAdminQuery();

  const company = data as AdminCompany;

  return (
    <Box>
      <EmailSettingsCard company={company} editClickedHandler={onOpen} />
      <Modal size="5xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Email Defaults</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <EmailSettingsForm {...{ company, isLoading, onClose }} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}
